import { NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  inject,
} from '@angular/core';
import { sleep } from '../../../lib/sleep';
import { AnalyticsService } from '../../../services/analytics.service';
import { SwitcherItemDirective } from '../../directives/switcher-item.directive';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class SwitcherComponent implements OnChanges, AfterViewInit {
  private check = inject(ChangeDetectorRef);
  @ContentChildren(SwitcherItemDirective, { read: TemplateRef }) templates: QueryList<TemplateRef<unknown>>;
  @ContentChildren(SwitcherItemDirective) items: QueryList<SwitcherItemDirective>;
  @Input() name: string;
  @Input() location: string;
  @Input() key: string;
  @Input() round: boolean;
  @Input() switcherStyle: 'dark' | 'light' = 'light';
  @Output() onChange = new EventEmitter();
  keys: string[] = [];
  _key: string;

  private analytics = inject(AnalyticsService);

  async ngAfterViewInit() {
    await sleep(0);
    this.keys = this.items.toArray().map(item => item.key);
    this.check.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.key && !changes.key.isFirstChange()) this.setMode(this.key);
  }

  toggle() {
    const index = this.keys.indexOf(this.key);
    let next = this.keys[index + 1];
    if (!next) next = this.keys[0];
    this.setMode(next);
  }

  public setMode(key: string) {
    if (this._key === key) return;
    this.key = key;
    this._key = key;
    this.onChange.emit(key);
    this.analytics.track('switcher', false, {
      name: this.name,
      location: this.location,
      key,
    });
  }

  isSelected(index: number) {
    if (!this.keys) return false;
    return this.keys[index] === this.key;
  }
}
